// extracted by mini-css-extract-plugin
export var productImage = "_zd-0";